export const getters = {
  getInformationIndex: (state) => {
      return state.informationIndex
  },
  getAreaId: (state) => {
      return state.areaId
  },
  getNavName: (state) => {
      return state.navName
  },
}


// WEBPACK FOOTER //
// ./src/store/getters.js